import validate from "/home/runner/work/parmazip-pharmacist/parmazip-pharmacist/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@18.19.75_db0@0.2.3_ioredis@5.4.2_magicast_a00c80da332b6686e7655eb7793ce6a3/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/parmazip-pharmacist/parmazip-pharmacist/src/middleware/auth.global.js";
import manifest_45route_45rule from "/home/runner/work/parmazip-pharmacist/parmazip-pharmacist/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@18.19.75_db0@0.2.3_ioredis@5.4.2_magicast_a00c80da332b6686e7655eb7793ce6a3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  redirect: () => import("/home/runner/work/parmazip-pharmacist/parmazip-pharmacist/src/middleware/redirect.js")
}